import errorLogin from './errorLogin'
import delItem from './delItem'
import addUser from './users/addUser'
import setGroupUser from './setInGroup'
import addThing from './things/addThing'
import addInfoBlock from './journal/addInfoBlock'
import delSingleProject from './projects/delSingleProject'
import addNewJournal from './journal/addNewJournal'
import addRole from './roles/addRole'
import addRoleInGroup from './roles/addRoleInGroup'
import assignRole from './roles/assignRole'
import del from './del'

export default {
  namespaced: true,
  state() {
    return {
      showOverlay: false,
      showRight: false,
      loader: false,
      virtualFlag: false
    }
  },
  mutations: {
    SHOW_OVERLAY(state,data) {
      state.showOverlay = data
    },
    SHOW_RIGHT(state,data) {
      state.showRight = data
    },
    SHOW_LOADER(state,data) {
      state.loader = data
    },
    SET_VIRTUAL_FLAG(state,data) {
      state.virtualFlag = data
    }
  },
  modules: {
    errorLogin,
    delItem,
    addUser,
    setGroupUser,
    addThing,
    addRole,
    addRoleInGroup,
    assignRole,
    del,
    addInfoBlock,
    addNewJournal,
    delSingleProject,
  }
}
